export type GuideArticle = {
  slug: string;
  title: string;
  description: string;
  category: string;
  publishedAt: string;
  readingMinutes: number;
  sections: { heading: string; paragraphs: string[] }[];
};

export const GUIDES: GuideArticle[] = [
  {
    slug: 'pos-selection-guide',
    title: '소상공인 마트 POS 프로그램, 어떻게 고를까?',
    description:
      '슈퍼·마트·편의점 사장님을 위한 POS 선택 기준. 재고관리, ESL, 키오스크 연동까지 실제 매장에서 확인해야 할 체크포인트를 정리했습니다.',
    category: 'POS 입문',
    publishedAt: '2026-06-02',
    readingMinutes: 8,
    sections: [
      {
        heading: '왜 POS 선택이 매출에 영향을 줄까',
        paragraphs: [
          '동네 슈퍼와 중소형 마트는 대형마트·편의점·이커머스와 동시에 경쟁합니다. 계산 속도, 가격 오류, 재고 파악 지연 같은 작은 운영 문제가 반복되면 고객 이탈과 폐기 손실로 이어집니다. POS는 단순 계산기가 아니라 매입·재고·판매·프로모션을 한곳에서 관리하는 매장 운영의 중심입니다.',
          '마트통포스는 소상공인 마트에 맞춰 AI 재고예측, ESL·POP 제작, 무인키오스크, CRM 모바일전단지까지 연결할 수 있도록 설계되었습니다. 도입 전에는 “지금 당장 필요한 기능”과 “6개월 뒤 확장할 기능”을 나누어 보는 것이 중요합니다.',
        ],
      },
      {
        heading: '도입 전 반드시 확인할 5가지',
        paragraphs: [
          '첫째, 업종 적합도입니다. 신선식품 비중이 높은 슈퍼와 공산품 중심 매장, 프랜차이즈·외식업은 재고 단위와 할인 정책이 다릅니다. 바코드·저울 연동, 할인·쿠폰, 반품 처리 흐름이 매장 실무와 맞는지 데모로 확인하세요.',
          '둘째, 재고·매입 관리입니다. 매입가 변동을 반영하지 못하면 마진이 왜곡됩니다. 실시간 또는 주기적으로 매입가·판매가를 조정하고, 폐기·반품·이동재고를 기록할 수 있는지 살펴보세요.',
          '셋째, 가격표시와 프로모션입니다. 종이 가격표 오류는 평균 수 %대에 이르는 경우가 많습니다. ESL(전자가격표)과 POP 제작 기능이 있으면 가격 변경 시간을 크게 줄이고 분쟁을 예방할 수 있습니다.',
          '넷째, 확장성입니다. 키오스크·무인매장·자체 쇼핑몰·회원 CRM을 나중에 붙일 계획이면, 처음부터 같은 데이터 기반으로 연동되는 솔루션이 유리합니다.',
          '다섯째, 설치·교육·A/S입니다. 전국 대리점·총판 네트워크와 전화·원격 지원 체계가 있는지, 교육 후 매장 직원이 혼자 운영할 수 있는 수준인지 확인하세요.',
        ],
      },
      {
        heading: '무료·저비용 도입이 가능한 경우',
        paragraphs: [
          '초기 비용 부담이 큰 소상공인에게는 지원 사업과 연계된 도입 경로도 있습니다. 마트통포스는 O2O 플랫폼 지원 사업을 통해 차세대 POS 및 POP 제작 프로그램을 무료 제공해 온 사례가 있으며, 전국 2,000여 가맹점과 50여 총판 대리점이 운영 중입니다.',
          '다만 “무료”만으로 결정하지 마세요. 데이터 이전(기존 상품·회원·단가), 주변기기(프린터·스캐너·저울), 교육 일정까지 포함한 총소유비용(TCO)을 비교하는 것이 안전합니다.',
        ],
      },
      {
        heading: '정리: 실무 중심의 선택 기준',
        paragraphs: [
          '좋은 POS는 화려한 기능 목록보다 “오늘 장사가 더 편해지는지”로 판단합니다. 계산·재고·가격·프로모션이 끊기지 않고 이어지는지, 직원이 실수하기 쉬운 지점을 시스템이 줄여주는지가 핵심입니다.',
          '마트통포스 도입 상담이 필요하면 고객문의 페이지 또는 02-6952-7652로 문의해 주세요. 매장 규모와 업종에 맞춰 필요한 기능만 우선 적용하는 단계적 도입도 가능합니다.',
        ],
      },
    ],
  },
  {
    slug: 'inventory-ai-prediction',
    title: '재고관리가 실패하는 이유와 AI 재고예측 활용법',
    description:
      '과다재고·품절이 반복되는 매장을 위한 재고관리 실전 가이드. 데이터 기반 발주와 AI 재고예측을 마트 현장에 맞게 설명합니다.',
    category: '재고관리',
    publishedAt: '2026-06-10',
    readingMinutes: 9,
    sections: [
      {
        heading: '소상공인 매장에서 재고가 흔들리는 구조',
        paragraphs: [
          '재고는 현금이 선반에 묶여 있는 상태입니다. 과다재고는 자금 회전을 막고 폐기·진부화를 키우며, 품절은 즉시 매출 기회 손실과 고객 신뢰 하락으로 이어집니다. 특히 신선·유제품·계절상품이 많은 동네 슈퍼에서는 하루 단위의 판단이 중요합니다.',
          '많은 매장이 “감”으로 발주합니다. 어제 팔린 양, 주말 손님 수, 날씨, 지역 행사까지 머릿속으로 감안하다 보면 담당자마다 기준이 달라지고, 휴가·교대 시 공백이 생깁니다. POS에 쌓인 판매 이력이 있어도 발주에 반영되지 않으면 데이터는 그냥 숫자가 됩니다.',
        ],
      },
      {
        heading: '실패 패턴 세 가지',
        paragraphs: [
          '첫째, 안전재고를 일괄적으로 두는 방식입니다. 회전이 빠른 생수와 느린 조미료에 같은 기준을 적용하면 한쪽은 넘치고 한쪽은 부족합니다. 상품군별·요일별·시즌별로 기준을 나눠야 합니다.',
          '둘째, 매입과 판매의 단절입니다. 매입가 변동을 늦게 반영하면 마진이 보이지 않고, 프로모션 후 재고 잔량이 남으면 정상가로 소화하기 어렵습니다.',
          '셋째, 창고·매대·카트 재고를 구분하지 않는 것입니다. 장부상 재고와 실제 매대 재고가 다르면 발주와 진열이 동시에 틀어집니다. ESL 연동 시에는 상품별·시간대별 재고 현황을 더 세밀히 볼 수 있습니다.',
        ],
      },
      {
        heading: 'AI 재고예측을 현장에 쓰는 방법',
        paragraphs: [
          '마트통포스의 AI 재고 최적화 예측은 과거 판매 데이터와 외부 요인을 분석해 미래 수요를 추정합니다. 목표는 “완벽한 예측”이 아니라 “사람이 빠뜨리기 쉬운 패턴을 보조”하는 것입니다. 주말·공휴일·날씨·프로모션 기간의 수요 변화를 참고 발주량으로 제시하면, 담당자는 예외 상품만 조정하면 됩니다.',
          '도입 초기에는 상위 판매 상품(매출 기여도 높은 SKU)부터 적용하세요. 전 품목을 한 번에 자동화하기보다, 폐기율이 높은 신선 카테고리와 품절이 잦은 인기 상품에 집중하는 편이 효과가 빠릅니다.',
          '매입가·판매가 동적 조정 기능과 함께 쓰면 원가 변동기에 마진을 방어하기 쉽습니다. 원자재·유통 단가가 바뀔 때 가격을 즉시 반영하고, ESL로 매대 가격을 동기화하면 가격표 교체 인력도 줄일 수 있습니다.',
        ],
      },
      {
        heading: '실행 체크리스트',
        paragraphs: [
          '1) 최근 3~6개월 판매·폐기 데이터를 POS에서 정리한다. 2) 품절·과다재고가 잦은 상위 50~100개 상품을 선정한다. 3) 요일·시즌 기준의 안전재고를 상품군별로 분리한다. 4) AI 예측값을 발주 초안으로 쓰고, 예외만 수동 조정한다. 5) 2주 단위로 폐기율·품절률을 비교해 기준을 미세 조정한다.',
          '재고관리는 한 번의 세팅이 아니라 주기적인 운영 루틴입니다. 마트통포스 상담을 통해 매장 데이터 상태에 맞는 도입 순서를 안내받을 수 있습니다.',
        ],
      },
    ],
  },
  {
    slug: 'kiosk-manless-checklist',
    title: '무인매장·키오스크 도입 전 체크리스트',
    description:
      '인건비 절감과 운영 효율을 위한 키오스크·무인매장 도입 가이드. 공간, 결제, 보안, 원격관리까지 사전에 확인할 항목을 모았습니다.',
    category: '키오스크·무인',
    publishedAt: '2026-06-18',
    readingMinutes: 8,
    sections: [
      {
        heading: '키오스크가 필요한 매장인가',
        paragraphs: [
          '키오스크는 피크 타임 줄 서기를 줄이고, 야간·주말 인력 부담을 완화하는 데 효과적입니다. 다만 모든 매장에 동일한 효과가 나지는 않습니다. 단품 계산이 많고 메뉴·상품 선택이 단순한 매장일수록 학습 비용이 낮고, 고령 고객 비중이 높거나 상담 판매가 많은 매장은 하이브리드(유인+키오스크)가 적합할 수 있습니다.',
          '마트통포스는 매장형 무인 키오스크와 모바일 키오스크를 POS와 연동해 제공합니다. 재고·가격·프로모션이 POS와 같아야 키오스크에서도 가격 분쟁이 생기지 않습니다.',
        ],
      },
      {
        heading: '도입 전 점검 항목',
        paragraphs: [
          '공간과 동선: 입구·계산대 앞·픽업존 중 어디에 둘지, 휠체어·유모차 동선을 막지 않는지 확인합니다. 결제 수단: 카드·간편결제·바우처 등 주 고객이 쓰는 수단을 지원하는지 확인합니다. 상품 마스터: 이미지·옵션·알레르기·중량 정보가 정리되어 있어야 키오스크 화면이 완성됩니다.',
          '보안과 도난 방지: 무인·부분무인 운영 시 CCTV, 출입 통제, 고가 상품 배치를 함께 설계합니다. 장애 대응: 결제 실패·프린터 용지·네트워크 장애 시 안내 문구와 원격 지원 연락처를 화면에 노출합니다.',
          '법적·운영 이슈: 주류·담배 등 연령 확인이 필요한 상품, 환불·교환 정책, 영수증 발급 방식을 사전에 정하세요.',
        ],
      },
      {
        heading: '무인매장 원격관리의 역할',
        paragraphs: [
          '무인매장은 “사람이 없는 매장”이 아니라 “현장에서 상시 상주하지 않는 매장”에 가깝습니다. 스마트폰으로 문 개폐, 장비 상태, 이상 알림을 확인하는 원격관리 시스템이 있어야 안정적으로 운영할 수 있습니다.',
          '마트통포스 무인매장 원격관리 솔루션은 실시간 모니터링으로 안정성과 신뢰성을 유지하고, 인력 최소화로 운영비를 줄이는 데 초점을 둡니다. 이상 징후가 보이면 가까운 관리자나 협력 점주가 출동하는 운영 규칙을 함께 만드세요.',
        ],
      },
      {
        heading: '단계적 도입 권장 순서',
        paragraphs: [
          '1단계: 피크 타임용 키오스크 1대 파일럿. 2단계: 야간·휴무일 부분 무인. 3단계: 원격관리·CCTV·재고 연동 고도화. 한 번에 완전 무인으로 전환하기보다, 고객 반응과 장애 빈도를 보고 범위를 넓히는 편이 안전합니다.',
          '도입 상담 시 매장 평수, 일 방문객, 주력 상품, 기존 POS 기종을 알려주시면 더 구체적인 구성을 제안할 수 있습니다.',
        ],
      },
    ],
  },
  {
    slug: 'esl-pop-efficiency',
    title: 'ESL·POP으로 가격표시와 매장 홍보 효율 높이기',
    description:
      '종이 가격표 교체 시간을 줄이고 프로모션을 빠르게 반영하는 ESL·POP 활용법. 오류율·인건비·친환경 효과까지 정리합니다.',
    category: '매장운영',
    publishedAt: '2026-06-25',
    readingMinutes: 7,
    sections: [
      {
        heading: '종이 가격표의 숨은 비용',
        paragraphs: [
          '가격 변경이 잦은 매장일수록 종이 가격표 작업은 인건비와 오류 리스크를 키웁니다. 일반적으로 종이 가격 표시 오류율은 수 %대에 이르는 경우가 많고, 잘못된 가격은 고객 불만과 손실로 이어집니다. 교체에만 수 시간이 걸리는 매장도 흔합니다.',
          'ESL(전자 스마트 라벨)은 실시간으로 가격을 반영해 종이 사용을 줄이는 Paperless 기술입니다. POP는 매대에서 가격·세일 정보를 전달하는 광고 매체로, 구매 직전 결정을 돕습니다.',
        ],
      },
      {
        heading: 'ESL이 주는 운영 효과',
        paragraphs: [
          '가격표시 오류를 줄여 손실과 분쟁을 예방하고, 가격 변경 시간을 수분 단위로 단축할 수 있습니다. 프로모션·예약 광고를 전자 라벨에 띄우면 POP를 대체하거나 보완할 수 있으며, 온라인 가격과 동기화하면 비교 쇼핑으로 인한 고객 유출을 완화하는 데도 도움이 됩니다.',
          '빅데이터 기반 프로모션과 연계하면 상품·시간대별 재고 현황을 보면서 할인 타이밍을 잡을 수 있습니다. UWB 등을 적용하면 디지털 쿠폰·로열티 프로그램 같은 개인화 서비스로 확장할 여지도 있습니다.',
        ],
      },
      {
        heading: 'POP 제작을 빠르게 하는 방법',
        paragraphs: [
          '디자인 인력이 없는 소상공인 매장에서는 POP 제작이 미뤄지기 쉽습니다. 마트통포스 POP 프로그램은 100여 가지 템플릿을 기본 제공해, 매장에서 바로 가격·세일 안내물을 만들 수 있습니다.',
          '효과적인 POP는 글자가 크고, 할인 이유와 기간이 명확하며, 매대 높이에 맞춰 가독성이 좋아야 합니다. 너무 많은 메시지를 넣으면 오히려 전달력이 떨어지므로 “한 POP = 한 메시지”를 원칙으로 하세요.',
        ],
      },
      {
        heading: '도입 시 현실적인 조언',
        paragraphs: [
          '전 매대를 한 번에 ESL로 바꾸기보다, 가격 변동이 잦은 카테고리부터 적용하는 것이 투자 대비 효과가 큽니다. POS와 가격 마스터가 먼저 정리되어 있어야 ESL·POP 효과가 제대로 납니다.',
          '마트통포스는 POS와 함께 ESL·POP 프로그램을 제공하므로, 가격 변경 → 매대 반영 → 홍보물 제작 흐름을 한 시스템에서 이어갈 수 있습니다.',
        ],
      },
    ],
  },
  {
    slug: 'crm-mobile-flyer',
    title: '동네 슈퍼 CRM·모바일전단지 마케팅 실전 가이드',
    description:
      '단골을 늘리는 회원 관리와 AI 모바일전단지 활용법. 촬영 부담 없이 전단지 제작·발송·주문까지 이어가는 방법을 안내합니다.',
    category: '마케팅',
    publishedAt: '2026-07-03',
    readingMinutes: 8,
    sections: [
      {
        heading: '소상공인 마케팅의 핵심은 재방문',
        paragraphs: [
          '신규 고객 유치 비용은 기존 고객 유지보다 높습니다. 동네 슈퍼는 거리와 신뢰가 경쟁력이므로, 회원 데이터로 “누가, 언제, 무엇을” 사는지를 파악하고 맞춤 혜택을 주는 CRM이 중요합니다.',
          '전단지·문자는 여전히 유효하지만, 제작 시간이 길고 반응을 측정하기 어렵다는 한계가 있습니다. 모바일전단지는 제작·발송·주문 반응을 한 흐름으로 볼 수 있어 운영 부담을 줄입니다.',
        ],
      },
      {
        heading: 'AI 모바일전단지가 바꾸는 업무',
        paragraphs: [
          '마트통포스 CRM 플랫폼은 상품 이미지 촬영이 없어도 AI 기술로 모바일전단지를 제작할 수 있도록 돕습니다. 완성된 이미지를 회원에게 일괄 발송하고, 실시간 주문까지 관리할 수 있어 “홍보 → 구매” 간격을 줄입니다.',
          '실무에서는 주간 특가, 신선 마감 할인, 지역 행사 연계 상품처럼 “오늘·이번 주”에 팔아야 하는 상품을 전면에 두는 것이 효과가 좋습니다. 너무 많은 SKU를 나열하기보다 8~12개 핵심 상품에 집중하세요.',
        ],
      },
      {
        heading: '발송 운영 루틴 예시',
        paragraphs: [
          '월요일: 주간 특가 전단지 제작·발송. 수요일: 중간 재고 소진용 리마인드. 금요일: 주말 신선·간편식 프로모션. 발송 후 클릭·주문·매장 방문 쿠폰 사용률을 보면 다음 주 구성을 개선할 수 있습니다.',
          '개인정보 동의와 수신 거부 처리를 반드시 지키세요. 과도한 발송은 차단율만 높입니다. 가치 있는 할인·재고 정보를 주는 “도움이 되는 메시지”가 장기적으로 열람율을 지킵니다.',
        ],
      },
      {
        heading: '쇼핑몰·CRM과 함께 쓰기',
        paragraphs: [
          '위치 기반의 매장 전용 쇼핑몰 앱과 CRM을 함께 쓰면, 오프라인 단골을 온라인 주문으로 확장할 수 있습니다. 주문·결제·배송·홍보를 모바일로 운영하고, 필요 시 인플루언서·지역 커뮤니티 홍보와 연결하는 방식도 가능합니다.',
          '마케팅 도구는 많아도 데이터가 흩어지면 효과가 반감됩니다. POS·CRM·쇼핑몰이 같은 상품·회원 정보를 공유하는 구조인지 확인하세요.',
        ],
      },
    ],
  },
  {
    slug: 'pos-replacement-timing',
    title: '마트 포스기 교체 시기와 비용 절감 포인트',
    description:
      '고장·속도 저하·기능 부족으로 고민될 때의 POS 교체 판단 기준. 데이터 이전, 주변기기, 교육까지 포함한 비용 절감 팁입니다.',
    category: '도입·교체',
    publishedAt: '2026-07-12',
    readingMinutes: 7,
    sections: [
      {
        heading: '교체를 고민해야 하는 신호',
        paragraphs: [
          '계산이 자주 멈추거나, 재고·매출 리포트가 믿을 수 없거나, 키오스크·ESL·모바일 주문 같은 확장이 막혀 있다면 교체 시점일 수 있습니다. “아직 켜지니까” 미루다 성수기에 장애가 나면 손실이 더 큽니다.',
          '운영체제·결제 모듈 보안 업데이트 중단, 영수증 프린터·스캐너 호환 문제, 직원마다 다른 수기 업무가 늘었다면 시스템 한계일 가능성이 높습니다.',
        ],
      },
      {
        heading: '비용은 기기값만이 아니다',
        paragraphs: [
          '총비용에는 소프트웨어, 하드웨어, 데이터 이전, 교육, 유지보수, 다운타임이 포함됩니다. 저가 장비만 비교하면 이후 커스터마이징·A/S 비용이 커질 수 있습니다.',
          '반대로, 지원 사업 연계로 프로그램 비용이 낮아지거나 기존 주변기기를 재사용할 수 있으면 체감 비용은 크게 줄어듭니다. 마트통포스는 소상공인 대상 종합 솔루션과 전국 총판 네트워크를 통해 설치·교육을 지원합니다.',
        ],
      },
      {
        heading: '교체 프로젝트 진행 순서',
        paragraphs: [
          '1) 현재 상품·단가·회원·포인트 데이터 백업. 2) 필수 기능 목록 확정(재고, 할인, 키오스크 등). 3) 피크가 아닌 요일에 파일럿 전환. 4) 직원 교육과 체크리스트 운영. 5) 2주간 병행 모니터링 후 완전 전환.',
          '데이터 정리가 가장 시간이 오래 걸립니다. 중복 바코드, 미사용 상품, 잘못된 원가를 미리 정리해 두면 전환 당일 혼란이 줄어듭니다.',
        ],
      },
      {
        heading: '전환 후 바로 챙겨야 할 것',
        paragraphs: [
          '매출·재고 리포트가 이전과 일치하는지, 카드 승인·취소가 정상인지, 가격 변경이 매대·키오스크에 동시에 반영되는지를 점검하세요. 문제 발생 시 연락 가능한 지원 채널을 계산대 근처에 붙여 두는 것도 도움이 됩니다.',
          '교체 상담은 고객문의 또는 02-6952-7652로 가능합니다. 매장 현황을 알려주시면 필요한 범위만 우선 적용하는 방안을 제안드립니다.',
        ],
      },
    ],
  },
];

export const getGuideBySlug = (slug: string) =>
  GUIDES.find((guide) => guide.slug === slug);

export const GUIDE_SLUGS = GUIDES.map((guide) => guide.slug);
